import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareAiPlanningRoute: InvariantJiraRoute = {
	name: 'software-ai-planning',
	path: '/jira/software/projects/:projectKey/ai-planning',
	exact: true,
};
